import {
  DruhKonstrukceKod,
  PripojeniKanalizaceKod,
  PripojeniPlynKod,
  PripojeniVodovodKod,
  TypStavebnihoObjektuKod,
  VybaveniVytahemKod,
  ZpusobVytapeniKod,
  ZpusobVyuzitiKod,
} from '../components/CadastreMap/types/RuianStavebniObjekt'

export interface PropertyListDetailAttributes {
  objectid: number
  kod: number
  nespravny: number | null
  cisladomovni: string | null
  identifikacniparcela: number | null
  typstavebnihoobjektukod: number | null
  zpusobvyuzitikod: number | null
  castobce: number | null
  momc: number | null
  platiod: number | null
  isknbudovaid: number | null
  dokonceni: number | null
  druhkonstrukcekod: number | null
  obestavenyprostor: number | null
  pocetbytu: number | null
  pocetpodlazi: number | null
  podlahovaplocha: number | null
  pripojenikanalizacekod: number | null
  pripojeniplynkod: number | null
  pripojenivodovodkod: number | null
  vybavenivytahemkod: number | null
  zastavenaplocha: number | null
  zpusobvytapenikod: number | null
  zdroj: number | null
  'st_area(shape)': number | null
  [k: string]: unknown
}

export const LABEL_ZPUSOB_VYUZITI: Record<number, string> = {
  [ZpusobVyuzitiKod.PrumyslovyObjekt]: 'Průmyslový objekt',
  [ZpusobVyuzitiKod.ZemedelskaUsedlost]: 'Zemědělská usedlost',
  [ZpusobVyuzitiKod.ObjektKBydleni]: 'Objekt k bydlení',
  [ZpusobVyuzitiKod.ObjektLesnihoHospodarstvi]: 'Objekt lesního hospodářství',
  [ZpusobVyuzitiKod.ObjektObcanskeVybavenosti]: 'Objekt občanské vybavenosti',
  [ZpusobVyuzitiKod.BytovyDum]: 'Bytový dům',
  [ZpusobVyuzitiKod.RodinnyDum]: 'Rodinný dům',
  [ZpusobVyuzitiKod.StavbaProRodinnouRekreaci]: 'Stavba pro rodinnou rekreaci',
  [ZpusobVyuzitiKod.StavbaProShromazdovaniVetsihoPoctuOsob]:
    'Stavba pro shromažďování osob',
  [ZpusobVyuzitiKod.StavbaProObchod]: 'Stavba pro obchod',
  [ZpusobVyuzitiKod.StavbaUbytovacihoZarizeni]: 'Stavba ubytovacího zařízení',
  [ZpusobVyuzitiKod.StavbaProVyrobuaSkladovani]:
    'Stavba pro výrobu a skladování',
  [ZpusobVyuzitiKod.ZemedelskaStavba]: 'Zemědělská stavba',
  [ZpusobVyuzitiKod.StavbaProAdministrativu]: 'Stavba pro administrativu',
  [ZpusobVyuzitiKod.StavbaObcanskehoVybaveni]: 'Stavba občanského vybavení',
  [ZpusobVyuzitiKod.StavbaTechnickehoVybaveni]: 'Stavba technického vybavení',
  [ZpusobVyuzitiKod.StavbaProDopravu]: 'Stavba pro dopravu',
  [ZpusobVyuzitiKod.Garaz]: 'Garáž',
  [ZpusobVyuzitiKod.JinaStavba]: 'Jiná stavba',
  [ZpusobVyuzitiKod.ViceucelovaStavba]: 'Víceúčelová stavba',
  [ZpusobVyuzitiKod.Sklenik]: 'Skleník',
  [ZpusobVyuzitiKod.Prehrada]: 'Přehrada',
  [ZpusobVyuzitiKod.HrazPrehrazujiciVodniTokNeboUdoli]:
    'Hráz přehrazující vodní tok',
  [ZpusobVyuzitiKod.HrazKOchraneNemovitostiPredZaplavenimPriPovodni]:
    'Protipovodňová hráz',
  [ZpusobVyuzitiKod.HrazOhrazujiciUmelouVodniNadrz]: 'Hráz umělé nádrže',
  [ZpusobVyuzitiKod.Jez]: 'Jez',
  [ZpusobVyuzitiKod.StavbaKPlavebnimUcelumVKorytechNeboNaBrezichVodnichToku]:
    'Plavební stavba',
  [ZpusobVyuzitiKod.StavbaKVyuzitiVodniEnergie]: 'Vodní elektrárna',
  [ZpusobVyuzitiKod.StavbaOdkaliste]: 'Stavba odkaliště',
  [ZpusobVyuzitiKod.RozestaveneJednotky]: 'Rozestavěné jednotky',
}

export const LABEL_TYP_SO: Record<number, string> = {
  [TypStavebnihoObjektuKod.BudovaSCislemPopisnym]: 's ČP',
  [TypStavebnihoObjektuKod.BudovaSCislemEvidencnim]: 's ČE',
  [TypStavebnihoObjektuKod.BudovaBezCPiCEv]: 'bez ČP/ČE',
}

export const LABEL_DRUH_KONSTRUKCE: Record<number, string> = {
  [DruhKonstrukceKod.CihlyTvarniceCihloveBloky]: 'Zděná / tvárnice',
  [DruhKonstrukceKod.Kamen]: 'Kámen',
  [DruhKonstrukceKod.KamenACihly]: 'Kámen a cihly',
  [DruhKonstrukceKod.StenovePanely]: 'Panel',
  [DruhKonstrukceKod.NepaleneCihly]: 'Nepálené cihly',
  [DruhKonstrukceKod.Drevo]: 'Dřevo',
  [DruhKonstrukceKod.JineMaterialyAKombinace]: 'Jiné materiály',
  [DruhKonstrukceKod.Nedefinovano]: 'Nedef.',
  [DruhKonstrukceKod.Nezjisteno]: 'Nezj.',
  [DruhKonstrukceKod.KamenCihlyTvarniceVcetneKombinaci]: 'Smíšené zdivo',
  [DruhKonstrukceKod.Monolit]: 'Monolit',
}

export const LABEL_KANALIZACE: Record<number, string> = {
  [PripojeniKanalizaceKod.PripojeniNaKanalizacniSit]: 'Veřejná',
  [PripojeniKanalizaceKod.VlastniCistickaOdpadnichVod]: 'Vlastní ČOV',
  [PripojeniKanalizaceKod.ZumpaJimka]: 'Žumpa / jímka',
  [PripojeniKanalizaceKod.BezKanalizaceAJimky]: 'Bez napojení',
  [PripojeniKanalizaceKod.Nedefinovano]: 'Nedef.',
  [PripojeniKanalizaceKod.Nezjisteno]: 'Nezj.',
}

export const LABEL_PLYN: Record<number, string> = {
  [PripojeniPlynKod.PlynZVerejneSite]: 'Veřejná síť',
  [PripojeniPlynKod.PlynZDomovnihoZasobniku]: 'Zásobník',
  [PripojeniPlynKod.BezPlynu]: 'NE',
  [PripojeniPlynKod.Nedefinovano]: 'Nedef.',
  [PripojeniPlynKod.Nezjisteno]: 'Nezj.',
  [PripojeniPlynKod.PlynVDome]: 'Plyn v domě',
}

export const LABEL_VODOVOD: Record<number, string> = {
  [PripojeniVodovodKod.SVodovodem]: 'ANO',
  [PripojeniVodovodKod.BezVodovodu]: 'NE',
  [PripojeniVodovodKod.Nezjisteno]: 'Nezj.',
}

export const LABEL_VYTAH: Record<number, string> = {
  [VybaveniVytahemKod.SVytahem]: 'ANO',
  [VybaveniVytahemKod.BezVytahu]: 'NE',
  [VybaveniVytahemKod.Nezjisteno]: 'Nezj.',
}

export const LABEL_VYTAPENI: Record<number, string> = {
  [ZpusobVytapeniKod.CentralniDomovni]: 'Centr. (dům)',
  [ZpusobVytapeniKod.CentralniDalkove]: 'Centr. (dálkové)',
  [ZpusobVytapeniKod.Lokalni]: 'Lokální',
  [ZpusobVytapeniKod.Jine]: 'Jiné / bez',
  [ZpusobVytapeniKod.Nezjisteno]: 'Nezjištěno',
}

const getOptions = (labels: Record<number, string>) =>
  Object.entries(labels).map(([value, text]) => ({
    text,
    value: Number(value),
  }))

export const propertyListDetailFilterOptions = {
  vytapeni: getOptions(LABEL_VYTAPENI),
  vytah: getOptions(LABEL_VYTAH),
  vodovod: getOptions(LABEL_VODOVOD),
  plyn: getOptions(LABEL_PLYN),
  kanalizace: getOptions(LABEL_KANALIZACE),
  druhKonstrukce: getOptions(LABEL_DRUH_KONSTRUKCE),
  zpusobVyuziti: getOptions(LABEL_ZPUSOB_VYUZITI),
}
